<div class="email">
  <div class="email__label">
    <ion-label>{{ question.label }}</ion-label>
  </div>

  <div class="input-group">
    <input
      type="email"
      #input
      #email="ngModel"
      required
      class="form-control type_msg"
      [class.has-error]="question.error"
      [class.is-invalid]="question.error"
      [placeholder]="question.label"
      [name]="question.key"
      [(ngModel)]="question.editingValue"
      (blur)="save()"
      (cdkAutofill)="save()"
      (keyup.enter)="save()"
      (ngModelChange)="question.error = null"/>
  </div>
</div>
